import { render, staticRenderFns } from "./DateFilter.vue?vue&type=template&id=36c8546c&scoped=true&"
import script from "./DateFilter.vue?vue&type=script&lang=js&"
export * from "./DateFilter.vue?vue&type=script&lang=js&"
import style0 from "./DateFilter.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./DateFilter.vue?vue&type=style&index=1&id=36c8546c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c8546c",
  null
  
)

export default component.exports